import { useCallback, useEffect, useMemo, useState } from 'react';

export const useContentOverlay = () => {
  const [isDisplayed, setDisplayed] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [top, setTop] = useState(0);

  useEffect(() => {
    const updatePosition = () => {
      if (isDisplayed) {
        setScrollPosition(window.pageYOffset);
      } else {
        setScrollPosition(0);
      }
    };
    window.addEventListener('scroll', updatePosition);
    updatePosition();
    return () => window.removeEventListener('scroll', updatePosition);
  }, [isDisplayed]);

  const open = useCallback(
    (pos = 0) => {
      setDisplayed(true);
      setTop(pos + scrollPosition);
    },
    [scrollPosition],
  );

  const close = () => {
    setDisplayed(false);
  };

  const memoizedObject = useMemo(
    () => ({
      isDisplayed,
      top: `${Math.max(0, top - scrollPosition)}px`,
      close,
      open,
    }),
    [isDisplayed, open, scrollPosition, top],
  );

  return memoizedObject;
};
